<template>
    <div :class="['container container-shadow mt-2 order-curve-right-end order-curve-left', cardClass]">
        <div class="row d-flex flex-grow-1">
            <div class="col-9 p-0 d-flex flex-column">
                <div class="d-flex flex-grow-1 order-row-height">
                    <div class="col mt-1 ml-1 d-flex justify-content-start align-items-center">
                        <h6 class="mb-0 text-sm">{{ instrument }}</h6>
                    </div>
                </div>
                <hr class="horizontal order-hr-line dark my-1" />
                <div class="row d-flex flex-grow-1 order-row-height">
                    <div class="col-6 text-center">
                        <div class="col-12 justify-content-center d-flex">
                            <small class="text-xxs text-info font-weight-bold">
                                {{ quantity }}
                            </small>
                        </div>
                        <small class="mb-0 text-sm text-gray">Quantity</small>
                    </div>
                    <div class="col-6 text-center">
                        <div class="col-12 justify-content-center d-flex">
                            <small class="text-xxs text-green font-weight-bold">
                                ₹ {{ price }}
                            </small>
                        </div>
                        <small class="mb-0 text-sm text-gray">Price</small>
                    </div>
                </div>
                <hr class="horizontal order-hr-line dark my-1" />
                <div class="row d-flex flex-grow-1 order-row-height">
                    <div class="ml-3 col text-center">
                        <div class="justify-content-start d-flex">
                            <small class="text-xxs text-gray font-weight-bold">
                                <i class="fa fa-clock px-1"></i> {{ formattedTimestamp }}
                            </small>
                        </div>
                        <div v-if="orderId" class="row justify-content-start d-flex align-items-center mt--2"
                            data-toggle="tooltip" data-placement="right" :title="`Order ID: ${orderId}`">
                            <small
                                class="text-xxs text-gray font-weight-bold text-truncate d-flex align-items-center col-9">
                                <i class="fa fa-hashtag px-1"></i> {{ orderId }}
                            </small>
                            <button @click="copyOrderId"
                                class="btn btn-link text-gray px-3 d-flex align-items-center col-2"
                                data-bs-toggle="tooltip" title="Copy">
                                <i class="fa fa-copy"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-3 d-flex flex-column ">
                <div class="row">
                    <div v-if="status === 'PENDING_CONFIRMED'"
                        class="col-6 bg-danger text-center d-flex align-items-center flex-grow-1 py-3">
                        <small class="text-white font-weight-bold text-sm d-flex align-items-center">
                            <span
                                class="btn-inner--icon text-white text-center font-weight-bold text-sm d-flex align-items-center">
                                <i class="fas fa-redo text-center "></i>
                            </span>
                        </small>
                    </div>
                    <div v-else class="col-6 bg-purple text-center d-flex align-items-center flex-grow-1 py-3">
                        <small class="text-white font-weight-bold text-sm d-flex align-items-center">
                            <span
                                class="btn-inner--icon text-white text-center font-weight-bold text-sm d-flex align-items-center">
                                <i class="fas fa-arrow-right text-white"></i>
                            </span>
                        </small>
                    </div>
                    <div
                        class="col-6 bg-primary enabled-action order-curve-right-top text-center d-flex align-items-center flex-grow-1 py-3">
                        <small @click="sendModalValue"
                            class="text-white font-weight-bold text-sm d-flex align-items-center">
                            <span class=" text-white d-flex align-items-center">
                                <i class="fas fa-eye text-center"></i>
                            </span>
                        </small>
                    </div>
                </div>
                <div v-if="trigger == 'BUY' || trigger == 'COVER'"
                    class="row d-flex flex-grow-1  bg-buy-cover text-center d-flex align-items-center">
                    <small class="mb-0 col text-sm text-green font-weight-bold">{{ capitalizeWords(trigger) }}</small>
                </div>
                <div v-else-if="trigger == 'SHORT' || trigger == 'SELL'"
                    class="row d-flex flex-grow-1 bg-sell-short text-center d-flex align-items-center">
                    <small class="mb-0 col text-sm text-danger font-weight-bold">{{ capitalizeWords(trigger) }}</small>
                </div>
                <hr class="horizontal order-hr-line dark my-0" />
                <div :class="statusClass"
                    class="row order-curve-right-end text-center d-flex flex-grow-1 align-items-center">
                    <small class="mb-0 col text-sm text-gray font-weight-bold">{{ displayStatus }}</small>
                </div>
                <hr class="horizontal order-hr-line dark my-0" />
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            showModal: false,
        };
    },
    name: "OrderCard",
    props: {
        trigger: { type: String, default: "" },
        optionsType: { type: String, default: "" },
        time: { type: String, default: "" },
        tradeDate: { type: String, default: "" },
        quantity: { type: Number, default: 0.0 },
        instrument: { type: String, default: "" },
        orderId: { type: String, default: "" },
        triggerData: { type: Object, default: {} },
        price: { type: Number, default: 0.0 },
        status: { type: Number, default: "" },
        exitType: { type: String, default: "" },
        isEntry: { type: Boolean },
        pnl: { type: Number, default: 0.0 },
    },
    computed: {
        parsedTriggerData() {
            try {
                return JSON.parse(this.triggerData);
            } catch (error) {
                return null;
            }
        },
        formattedTimestamp() {
            const date = new Date(`${this.tradeDate}T${this.time}`);
            const yyyy = date.getFullYear();
            const MM = String(date.getMonth() + 1).padStart(2, '0');
            const dd = String(date.getDate()).padStart(2, '0');
            const hh = String(date.getHours()).padStart(2, '0');
            const mm = String(date.getMinutes()).padStart(2, '0');
            const ss = String(date.getSeconds()).padStart(2, '0');
            const timestamp = `${dd}/${MM}/${yyyy} ${hh}:${mm}:${ss}`;
            return timestamp;
        },
        displayStatus() {
            switch (this.status) {
                case "PENDING": return "P";
                case "PENDING_CONFIRMED": return "PC";
                case "INSUFFICIENT_QTY": return "IQ";
                case "CANCELLED": return "CN";
                case "COMPLETE": return "CM";
                case "REJECTED": return "R";
                case "OPEN": return "O";
                case "UPDATE": return "U";
                default: return this.status;
            }
        },
        statusClass() {
            switch (this.status) {
                case "PENDING": return 'bg-pending';
                case "PENDING_CONFIRMED": return 'bg-pc';
                case "INSUFFICIENT_QTY": return 'bg-iq';
                case "CANCELLED": return 'bg-pink';
                case "COMPLETE": return 'bg-cancelled';
                case "REJECTED": return 'bg-light';
                case "OPEN": return 'bg-open';
                case "UPDATE": return 'bg-update';
                default: return 'bg-secondary';
            }
        },
        cardClass() {
            return this.isEntry ? 'bg-entry' : 'bg-exit';
        }
    },
    methods: {
        capitalizeWords(value) {
            if (!value) return '';
            return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
        },
        copyOrderId() {
            const el = document.createElement('textarea');
            el.value = this.orderId;
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
        },
        sendModalValue() {
            this.showModal = true;
            this.$emit('modalValue', this.showModal, this.parsedTriggerData, this.pnl, this.exitType);
        }
    },
};
</script>
<style scoped></style>
